import { computed, ComputedRef, Ref, ref } from 'vue'

export const DashboardContextSymbol = Symbol('DashboardContext')

export type DashboardContext = {
  dateFilters: Ref<Date[]>
  setDateFilters: (dates: Date[]) => void
  formattedDateFilters: ComputedRef<{
    filters?: {
      startDate: string
      endDate: string
    }
  }>
  hasFiltersApplied: ComputedRef<boolean>
}

export const dashboardContextDefault: DashboardContext = {
  dateFilters: ref([]),
  setDateFilters: () => ({}),
  formattedDateFilters: computed(() => ({})),
  hasFiltersApplied: computed(() => false),
}
